// @create-index
export { default as apple } from './apple.js';
export { default as burger } from './burger.js';
export { default as cake } from './cake.js';
export { default as coffeeCup } from './coffee-cup.js';
export { default as coffeeMug } from './coffee-mug.js';
export { default as donut } from './donut.js';
export { default as pizza } from './pizza.js';
export { default as popsicle } from './popsicle.js';
export { default as soup } from './soup.js';
export { default as strawberry } from './strawberry.js';
export { default as turkey } from './turkey.js';
export { default as watermelon } from './watermelon.js';
//# sourceMappingURL=index.js.map